import { createSelector } from '@ngrx/store';
import { isEmpty,get } from 'lodash';

import { ScreenContext } from './states';
import { PAGE, SIZE, TOTAL_ITEMS, ROWS_SELECTED, VARS } from './constants';

/**
 * Select the feature from the state
 */
export const getFeatureState = createSelector(
  (state, props: ScreenContext) => state[props.feature],
  state => state
);
/**
 * Select the component's screen from the feature's state
 */
export const getScreenState = createSelector(
  getFeatureState,
  (state, props: any) => state[props.screenType]
);
/**
 * Select the value of the component's screen
 */
export const selectValue = createSelector(
  getScreenState,
  (state, props: any) => {
    return state.entities[props.screenId]
      ? state.entities[props.screenId].value
      : [];
  }
);
/**
 * Select the value of the component's screen
 */
export const selectScreenState = createSelector(
  getScreenState,
  (state, props: any) => {
    return state.entities[props.screenId] ? state.entities[props.screenId] : {};
  }
);
/**
 * select the possible values for a given field
 */
export const possibleValues = createSelector(
  getScreenState,
  (state, props: any) => {
    return state.entities[props.screenId] &&
      state.entities[props.screenId].possibleValues
      ? state.entities[props.screenId].possibleValues[props.field] || []
      : [];
  }
);
/**
 * Select the loading property of the component's screen
 */
export const selectLoading = createSelector(
  getScreenState,
  (state, props: any) => {
    return state.entities[props.screenId]
      ? state.entities[props.screenId].loading
      : false;
  }
);
/**
 * Select the loading property of the component's screen
 */
export const checkValidation = createSelector(
  getScreenState,
  (state, props: any) => {
    return state.entities[props.screenId]
      ? state.entities[props.screenId].validate
      : false;
  }
);
/**
 * Select the loading property of simple page (no entitites)
 * like Auth state
 */
export const selectPageLoading = createSelector(
  getFeatureState,
  (state, props: any) => {
    return state && state.loading ? state.loading : false;
  }
);
/**
 * Select the path property of the component's screen
 */
export const selectPath = createSelector(
  getScreenState,
  (state, props: any) => {
    return state.entities[props.screenId]
      ? state.entities[props.screenId].path
      : null;
  }
);
/**
 * Select the context variables for search screen such as: pageSize, criteria, pageNumber...
 */
export const selectSearchVars = createSelector(
  getScreenState,
  (state, props: any) => {
    return state.entities[props.screenId]
      ? state.entities[props.screenId][VARS]
      : {};
  }
);
/**
 * Select the loading property of the component's screen
 */
export const selectPageSize = createSelector(
  selectSearchVars,
  (state, props: any) => {
    return !isEmpty(state) ? state[SIZE] : 10;
  }
);
/**
 * Select the page number property of the component's screen
 */
export const selectPage = createSelector(
  selectSearchVars,
  (state, props: any) => {
    return !isEmpty(state) ? state[PAGE] : 1;
  }
);
/**
 * Select the rows selected property from the collection screen
 */
export const selectRowsSelected = createSelector(
  getScreenState,
  (state, props: any) => {
    return state.entities[props.screenId]
      ? state.entities[props.screenId][ROWS_SELECTED]
      : [];
  }
);

/**
 * Select the count property of the component's screen
 */
export const selectCount = createSelector(
  getScreenState,
  (state, props: any) => {
    return state.entities[props.screenId]
      ? state.entities[props.screenId][TOTAL_ITEMS]
      : 0;
  }
);
/**
 * Select a property from screen's state
 */
export const selectProperty = createSelector(
  getScreenState,
  (state, props: any) => {
    return state.entities[props.screenId]
      ? state.entities[props.screenId][props.property]
      : props.defaultValue;
  }
);
/**
 * Select the entities of the value of a collection screen
 */
export const selectEntitiesValue = createSelector(selectValue, state => {
  if (state) {
    const entities = state.entities;
    if (entities) {
      const values = Object.keys(entities);
      return values.map(entity => {
        const item = { ...entities[entity] };
        item.code = entity;
        return item;
      });
    } else {
      return [];
    }
  } else {
    return [];
  }
});
/**
 * Select the value of the provided role from a screen's value
 * If the screen's type collection,
 * the value's structure': value {ids: [], entities: {} }
 * If the screen's type form or view, the value is a json object
 */
export const selectRoleValue = createSelector(selectValue, (state, props: any) => {
  return state['entities'] ? state['entities'][props.code] : get(state,props.roleName);
});
/**
 * Select the roleName/value of comonent provided
 * the value's structure': value {ids: [], entities: {} }
 */
export const selectRoleNameValue = createSelector(getScreenState, (state, props: any) => {
  const value = {...state['entities'][props.screenId].value};
  const roleValue = value && value[props.roleName];
  const screenValue = value && value.entities && Object.values(value.entities);
  return screenValue || roleValue;
});
